// ============================================================================
// FILE: src/modules/invoice/pages/InvoiceListPage.jsx
// CREATED: 2025-12-03
// UPDATED: 2025-12-03 — Added gradient buttons using plain CSS
// PURPOSE: Display table of invoices + action buttons
// ============================================================================

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import invoiceService from "../services/invoiceService";

const InvoiceListPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadInvoices();
  }, []);

  const loadInvoices = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await invoiceService.getInvoices(1);

      if (response.success) {
        setInvoices(response.invoices || []);
      } else {
        setError(response.message || "Failed to fetch invoices.");
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred while loading invoices.");
    } finally {
      setLoading(false);
    }
  };

  const handleView = (id) => {
    navigate(`/invoices/${id}`);
  };

  return (
    <div className="p-4">

      {/* ================= HEADER + BUTTONS ================= */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="fw-bold fs-2">Invoice List</h1>

        <div className="d-flex gap-3">

          {/* 🌈 Upload Invoice (Gradient) */}
          <button
            onClick={() => navigate("/invoices/upload")}
            style={{
              background: "linear-gradient(90deg, #FF4DCF, #B800B8)",
              border: "none",
              color: "white",
              padding: "8px 18px",
              borderRadius: "8px",
              fontWeight: "600",
              boxShadow: "0px 3px 6px rgba(0,0,0,0.2)",
            }}
          >
            Upload Invoice
          </button>

          {/* Disabled Button */}
          <button
            disabled
            style={{
              background: "#d1d1d1",
              border: "none",
              color: "white",
              padding: "8px 18px",
              borderRadius: "8px",
              opacity: 0.6,
            }}
          >
            Validate
          </button>

          {/* Disabled Button */}
          <button
            disabled
            style={{
              background: "#d1d1d1",
              border: "none",
              color: "white",
              padding: "8px 18px",
              borderRadius: "8px",
              opacity: 0.6,
            }}
          >
            Analytics
          </button>

        </div>
      </div>
      {/* ===================================================== */}

      {loading && <p>Loading invoices...</p>}
      {error && <p className="text-danger">{error}</p>}

      {!loading && invoices.length === 0 && (
        <p>No invoices found.</p>
      )}

      {!loading && invoices.length > 0 && (
        <div className="table-responsive bg-white shadow rounded">
          <table className="table table-striped">
            <thead className="table-light">
              <tr>
                <th>Invoice No</th>
                <th>Vendor</th>
                <th>Date</th>
                <th>Total</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((inv) => (
                <tr key={inv.id}>
                  <td>{inv.invoice_number || "-"}</td>
                  <td>{inv.vendor_name || "-"}</td>
                  <td>{inv.invoice_date || "-"}</td>
                  <td>{inv.total_amount || "-"}</td>
                  <td>{inv.status || "-"}</td>
                  <td>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => handleView(inv.id)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
};

export default InvoiceListPage;
